export enum MatTableInputTypeEnum {
  LABEL = 1,
  INPUT = 2,
  INPUT_NUMBER = 3,
  AUTO_COMPLETE = 4,
  SELECT_FIELD = 5,
  SIMPLE_AUTOCOMPLETE = 6,
  LABEL_NUMBER = 7,
  CHECK_BOX_FORM = 8,
  DATE_FIELD = 9,
  CHECK_BOX_CONSULT = 10,
  SELECT_EVENT = 11,
  SELECT_ID = 12,
  CUSTOM = 13,
  INPUT_TEXT_AREA = 14,
  MAT_CHIP_LIST_AUTO_COMPLETE_COMBINED = 15,
  SEARCH_RIGHT_HOLDER_BUTTON = 16,
  MAT_LIST = 17
}
